import clsx from 'clsx';
import { Typography } from '@ag1/ui';
import styles from './InfoItemRow.module.scss';
import { InfoItemProps } from './InfoItemDetails.types';

const InfoItem = ({
  label,
  value,
  className,
  subscriptionTitle,
  fontWeight,
  dataTestId
}: InfoItemProps) => {
  const classItem = clsx(styles.item, className);

  return (
    <div className={classItem}>
      <Typography
        variant="portalText"
        size="1"
        color="grey-1-new"
        noPadding
        hidden={subscriptionTitle && value === 'One-time purchase'}>
        {label}
      </Typography>
      <Typography
        variant="portalText"
        size="1"
        weight={fontWeight || '700'}
        color="black-new"
        noPadding
        dataTestId={dataTestId}>
        {value}
      </Typography>
    </div>
  );
};

export default InfoItem;
